const FONT_FAMILY = '"Roboto", "Helvetica", "Arial", sans-serif';

export type TextType = {
	size: number;
	weight?: number;
};

let context: CanvasRenderingContext2D | null | undefined;
const measured = new Map<string, number>();

export const textWidth = (text: string, { size, weight = 400 }: TextType) => {
	const font = `${weight} ${size}px ${FONT_FAMILY}`;
	const key = `${font}|${text}`;
	const known = measured.get(key);

	if (known !== undefined) return known;

	if (context === undefined)
		context =
			typeof document === "undefined"
				? null
				: document.createElement("canvas").getContext("2d");

	if (context) context.font = font;
	const width = context
		? Math.ceil(context.measureText(text).width)
		: Math.ceil(text.length * size * 0.55);

	measured.set(key, width);

	return width;
};
